{
  "judgement": {
    "kind": {
      "additive": "Additive",
      "rate": "Rate",
      "level": "Level"
    },
    "direction": {
      "higherIsBetter": "Higher is better",
      "lowerIsBetter": "Lower is better",
      "band": "Within a band",
      "neutral": "Not judged"
    }
  },
  "fields": {
    "unit": "Unit",
    "targetType": "Target type",
    "none": "None"
  },
  "dimensions": {
    "plantMobileEquipment": "Plant",
    "plantType": "Plant Type",
    "jobType": "Job Type",
    "stage": "Stage",
    "analyte": "Analyte"
  },
  "targetTypes": {
    "title": "Target Types",
    "intro": "System types are managed by Eclipse and cannot be renamed. User-defined types can be created here and will appear in the Targets page. Ore/Waste tells reporting which production rows a target belongs against; leave it as Both when the metric covers ore and waste together. Kind says how values combine over a period: additive figures are pro-rated, a rate is weighted by its multiplier, and a level is the value on the period's last day. Direction says which way is good, and a band is on target within the tolerance either side.",
    "unitPlaceholder": "e.g. t, m, %, g/t",
    "sort": "Sort",
    "multiplier": "Multiplier",
    "kind": "Kind",
    "direction": "Direction",
    "band": "Band ±%",
    "opArea": "Op. Area",
    "oreWaste": "Ore/Waste",
    "system": "System",
    "card": "Card",
    "allAreas": "All areas",
    "both": "Both",
    "cardShow": "Show on the dashboard's targets card",
    "cardNoActual": "The targets card has no actual for this type",
    "deactivateConfirm": "Deactivate \"{{name}}\"? Existing targets using this type will be preserved.",
    "systemType": "System type",
    "deactivated": "Target type deactivated",
    "nameRequired": "Name is required",
    "updated": "Target type updated",
    "created": "Target type created",
    "onCard": "{{name}} is on the targets card",
    "offCard": "{{name}} is off the targets card"
  },
  "targetsPage": {
    "seeBelow": "See below",
    "mineWide": "Mine-wide",
    "jobFallback": "Job {{id}}",
    "noDimensions": "This Target Type does not support scope dimensions.",
    "previousMonth": "Previous month",
    "nextMonth": "Next month",
    "from": "From:",
    "to": "To:",
    "addForAll": "Add for all targets",
    "addForAllConfirm": "This will add an empty Target record for all active Target Types if one doesn't already exist for the specified Date From.",
    "hideSingleDay": "Hide single day Targets",
    "scopeDimension": "Scope dimension",
    "scopeValue": "Scope value",
    "value": "Value",
    "scope": "Scope",
    "reconciled": "Reconciled",
    "deleted": "Target deleted successfully",
    "updated": "Target updated successfully",
    "added": "Target added successfully",
    "allAdded": "Targets added successfully",
    "addAllFailed": "Failed to add targets, please try again.",
    "categoryRequired": "Target category is required",
    "categoryNotFound": "Target category not found",
    "editValidation": {
      "typeRequired": "Target Type is required",
      "dateFromRequired": "Date From is required",
      "dateToRequired": "Date To is required",
      "dateOrder": "Date From must be earlier than Date To",
      "valueMin": "Target value must be 0 or greater"
    },
    "newValidation": {
      "typeRequired": "Target type is required",
      "dateFromRequired": "Date from is required",
      "dateToRequired": "Date to is required",
      "dateOrder": "Date from must be before Date to"
    }
  },
  "importLabels": {
    "category": {
      "forecast": "Forecast",
      "plan": "Plan",
      "budget": "Budget",
      "actuals": "Actuals"
    },
    "dimensionSource": {
      "notApplicable": "Not applicable",
      "fixed": "Fixed value",
      "rowLabel": "Row label",
      "columnHeader": "Column header",
      "sectionHeader": "Section header"
    },
    "entityTargetType": "Target Type",
    "runStatus": {
      "success": "Success",
      "partial": "Partial",
      "failed": "Failed"
    }
  },
  "import": {
    "smartAnalysis": "Smart File Analysis",
    "dropPrompt": "Drag & drop an Excel file here, or click to browse",
    "excelOnly": "Please select an Excel file (.xlsx or .xls).",
    "fileSize": "{{size}} KB",
    "fileSizeChange": "{{size}} KB · click to change file",
    "selectPlaceholder": "Select…",
    "entityType": "Entity type",
    "sheet": "Sheet",
    "category": "Category"
  },
  "importList": {
    "title": "Target Import",
    "newTemplate": "New Template",
    "templatesTab": "Templates",
    "runHistoryTab": "Run History",
    "runs": "Runs",
    "lastRun": "Last Run",
    "noTemplates": "No templates yet. Create one manually or use Smart File Analysis.",
    "never": "Never",
    "runImport": "Run import",
    "editTemplate": "Edit template",
    "deleteTemplate": "Delete template",
    "template": "Template",
    "file": "File",
    "dateRange": "Date Range",
    "imported": "Imported",
    "skipped": "Skipped",
    "runAt": "Run At",
    "noRuns": "No import runs yet.",
    "unknownStatus": "Unknown",
    "loadTemplatesFailed": "Failed to load templates.",
    "loadRunsFailed": "Failed to load run history.",
    "deleteFailed": "Failed to delete template.",
    "deleted": "Template \"{{name}}\" deleted.",
    "deleteConfirm": "Delete template \"{{name}}\"? This cannot be undone."
  },
  "analyze": {
    "intro": "Upload an Excel file, choose a sheet, and let our file analysis system suggest an import template configuration.",
    "sheetReadFailed": "Could not read sheet names from file.",
    "workbookFailed": "Failed to read workbook.",
    "analysisFailed": "Analysis failed. Check API configuration.",
    "requestFailed": "Analysis request failed.",
    "readingSheets": "Reading worksheets…",
    "selectSheet": "Select sheet to analyse",
    "sheetsFound_one": "({{count}} sheet found)",
    "sheetsFound_other": "({{count}} sheets found)",
    "hiddenSheet": "Hidden sheet",
    "analysing": "Analysing…",
    "analyse": "Analyse Sheet",
    "analysingSheet": "Analysing <strong>{{sheet}}</strong>. We are reading the sheet structure and mapping columns to Eclipse entities. This may take 15-30 seconds.",
    "complete": "Analysis Complete",
    "confidence": {
      "high": "high confidence",
      "medium": "medium confidence",
      "low": "low confidence",
      "other": "{{level}} confidence"
    },
    "summary": "Summary",
    "notes": "Notes",
    "suggestedTemplate": "Suggested Template",
    "unnamed": "(unnamed)",
    "unknown": "(unknown)",
    "sections": "Sections",
    "columnMappings": "Column mappings",
    "noSuggestion": "We could not produce a suggested template for this sheet. You can still create a template manually, or try a different sheet.",
    "lowConfidence": "We had low confidence in this analysis. Review the suggested template carefully before saving.",
    "analyseAnother": "Analyse Another File",
    "differentSheet": "Try a Different Sheet",
    "reviewSave": "Review & Save Template"
  },
  "run": {
    "steps": {
      "upload": "Upload File",
      "preview": "Preview",
      "execute": "Execute",
      "results": "Results"
    },
    "loadFailed": "Failed to load template.",
    "previewFailed": "Preview failed.",
    "previewRequestFailed": "Preview request failed.",
    "executeFailed": "Execute failed.",
    "executeRequestFailed": "Execute request failed.",
    "mapAllLabels": "Please map all labels before continuing.",
    "resolutionFailed": "Label resolution failed.",
    "resolutionRequestFailed": "Label resolution request failed.",
    "title": "Run Import",
    "template": "Template: {{name}}",
    "templateWithLabel": "Template: {{name}} · {{label}}",
    "dateOffset": "Date Offset (days)",
    "dateOffsetHelp": "Shift all dates by N days",
    "overwrite": "Overwrite existing rows",
    "previewing": "Previewing…",
    "previewFile": "Preview File",
    "rowsDetected": "Rows detected",
    "rowsSkipped": "Rows skipped",
    "dateRange": "Date range",
    "notApplicable": "N/A",
    "warnings": "Warnings",
    "labelsNeedMapping_one": "{{count}} dimension label(s) need mapping",
    "labelsNeedMapping_other": "{{count}} dimension label(s) need mapping",
    "labelsNeedMappingHelp": "Labels such as location or material type names were found in the file that have not been matched to Eclipse entities yet. You will be prompted to map them after executing; once saved, they will be remembered for future runs with this template.",
    "sampleRows": "Sample rows (first {{number}})",
    "skipReasons": "Skip reasons",
    "back": "Back",
    "executing": "Executing…",
    "executeImport": "Execute Import",
    "running": "Running import…",
    "unmatched_one": "{{count}} label(s) could not be automatically matched.",
    "unmatched_other": "{{count}} label(s) could not be automatically matched.",
    "unmatchedHelp": "Map each label to an existing entity; the import will re-run with your choices.",
    "labelInFile": "Label in file",
    "mapTo": "Map to",
    "aiSuggestion": "AI suggestion",
    "backToPreview": "Back to Preview",
    "stillNeedMapping_one": "{{count}} label(s) still need mapping",
    "stillNeedMapping_other": "{{count}} label(s) still need mapping",
    "confirmRerun": "Confirm & Re-run",
    "complete": "Import Complete",
    "recordsImported": "Records imported",
    "recordsSkipped": "Records skipped",
    "errors_one": "{{count}} error(s) during import",
    "errors_other": "{{count}} error(s) during import",
    "skippedRows_one": "{{count}} skipped row",
    "skippedRows_other": "{{count}} skipped rows",
    "backToList": "Back to Import List",
    "runAnother": "Run Another Import"
  },
  "templateEditor": {
    "nameRequired": "Template name is required.",
    "created": "Template created successfully.",
    "updated": "Template updated successfully.",
    "newTitle": "New Import Template",
    "editTitle": "Edit: {{name}}",
    "create": "Create",
    "basicInfo": "Basic Info",
    "templateName": "Template name",
    "templateLabel": "Label (human-friendly)",
    "sheetName": "Sheet name",
    "structure": "Structure",
    "orientation": "Orientation",
    "columnBased": "Column-based (grid)",
    "rowBased": "Row-based (one record per row)",
    "headerRowCount": "Header row count",
    "dataStartRow": "Data start row (0-based)",
    "rowLabelColumn": "Row label column (0-based)",
    "dateSource": "Date source",
    "fixedRange": "Fixed range",
    "rowColumnIndex": "Row (column index)",
    "columnHeaderRow": "Column header row",
    "dateHeaderRowIndex": "Date header row index (0-based)",
    "dateColumnIndex": "Date column index (0-based)",
    "fixedDateFrom": "Fixed date from",
    "fixedDateTo": "Fixed date to",
    "dimensions": "Dimensions",
    "dimension": {
      "location": {
        "source": "Location source",
        "fixed": "Fixed location"
      },
      "stage": {
        "source": "Stage source",
        "fixed": "Fixed stage"
      },
      "materialType": {
        "source": "Material type source",
        "fixed": "Fixed material type"
      },
      "plant": {
        "source": "Plant source",
        "fixed": "Fixed plant"
      },
      "plantType": {
        "source": "Plant type source",
        "fixed": "Fixed plant type"
      },
      "analyte": {
        "source": "Analyte source",
        "fixed": "Fixed analyte"
      }
    },
    "columnIndex": "Column index (0-based)",
    "fixedId": "Fixed ID",
    "sections": "Sections ({{number}})",
    "sectionsHelp": "Sections detect header rows in the data and optionally assign a Location, Stage, MaterialType, or TargetType override to all rows beneath them.",
    "sectionLabel": "Section label",
    "detectionPattern": "Detection pattern (regex or text)",
    "sortOrder": "Sort order",
    "dimensionType": "Dimension type",
    "resolvedEntity": "Resolved entity",
    "unresolved": "Unresolved",
    "targetTypeOverride": "Target type override",
    "noneUseMapping": "None (use column mapping)",
    "removeSection": "Remove section",
    "addSection": "Add section",
    "columnMappings": "Column Mappings ({{number}})",
    "columnMappingsHelp": "For RowBased: map a column index to a target type. For ColumnBased: map a row index to a target type. A pin gives every row a mapping produces a material type or analyte, for rows such as \"Au grade\" or \"MG\" whose label is the dimension.",
    "index": "Index (0-based)",
    "originalLabel": "Original label",
    "sectionLabelOptional": "Section label (optional)",
    "materialTypePin": "Material type pin",
    "analytePin": "Analyte pin",
    "removeMapping": "Remove mapping",
    "addMapping": "Add mapping",
    "referenceMap": "Reference Map ({{number}})",
    "referenceMapHelp": "Maps spreadsheet text labels to Eclipse entity IDs. Add entries here for labels the import parser must recognise.",
    "sourceText": "Source text",
    "mapsTo": "Maps to",
    "removeEntry": "Remove entry",
    "addEntry": "Add entry",
    "behaviour": "Behaviour",
    "skipZero": "Skip zero values",
    "excludePatterns": "Exclude row patterns",
    "excludePatternsHelp": "Rows whose label contains any of these strings will be skipped (e.g. \"Total\", \"Grand Total\").",
    "addPattern": "Add pattern",
    "createTemplate": "Create Template"
  }
}
